export const newId = (): string => crypto.randomUUID();
